import React from "react";
import { Box, Typography, IconButton, Tooltip } from "@mui/material";
import { HiOutlineChevronLeft as MenuOpenIcon } from "react-icons/hi2";
import { colors, fonts, spacing, borderRadius } from "../../constants";
import logoImage from "../../assets/logo2.png";

/**
 * SidebarHeader Component
 * Displays the logo and toggle button for the sidebar
 *
 * @param {boolean} isCollapsed - Whether the sidebar is collapsed
 * @param {function} onToggle - Callback function to toggle sidebar
 */
const SidebarHeader = ({ isCollapsed, onToggle }) => {
  return (
    <Box
      sx={{
        px: spacing.sm,
        py: 0,
        borderBottom: `1px solid rgba(255, 255, 255, 0.1)`,
        minHeight: "48px",
        height: "48px",
        maxHeight: "48px",
        display: "flex",
        alignItems: "center",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15), 0 1px 2px rgba(0, 0, 0, 0.1)"
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: isCollapsed ? "center" : "space-between",
          gap: spacing.xs,
          width: "100%"
        }}
      >
        {isCollapsed ? (
          <Tooltip title="Expand Sidebar" placement="right">
            <Box
              onClick={onToggle}
              sx={{
                width: 36,
                height: 36,
                borderRadius: borderRadius.sm,
                background: "linear-gradient(135deg, #ffffff 0%, #e0e7ff 100%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 4px 12px rgba(255, 255, 255, 0.2)",
                cursor: "pointer",
                transition: "all 0.2s ease",
                "&:hover": {
                  transform: "scale(1.05)",
                  boxShadow: "0 6px 16px rgba(255, 255, 255, 0.3)"
                }
              }}
            >
              <Box
                component="img"
                src={logoImage}
                alt="Airport Authority of India logo"
                sx={{
                  width: 24,
                  height: 24,
                  objectFit: "contain"
                }}
              />
            </Box>
          </Tooltip>
        ) : (
          <>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: spacing.xs,
                flex: 1
              }}
            >
              <Box
                sx={{
                  width: 36,
                  height: 36,
                  borderRadius: borderRadius.sm,
                  background:
                    "linear-gradient(135deg, #ffffff 0%, #e0e7ff 100%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 4px 12px rgba(255, 255, 255, 0.2)"
                }}
              >
                <Box
                  component="img"
                  src={logoImage}
                  alt="Airport Authority of India logo"
                  sx={{
                    width: 32,
                    height: 32,
                    objectFit: "contain"
                  }}
                />
              </Box>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: fonts.weightBold,
                  fontSize: fonts.fontSizeSm,
                  color: colors.textWhite,
                  letterSpacing: "-0.01em",
                  lineHeight: 1.3
                }}
              >
                Airports Authority of India
              </Typography>
            </Box>
            <Tooltip title="Collapse Sidebar" placement="right">
              <IconButton
                onClick={onToggle}
                size="small"
                sx={{
                  color: "rgba(255, 255, 255, 0.7)",
                  width: 32,
                  height: 32,
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                    color: colors.textWhite
                  }
                }}
              >
                <MenuOpenIcon
                  style={{ fontSize: "20px", width: "20px", height: "20px" }}
                />
              </IconButton>
            </Tooltip>
          </>
        )}
      </Box>
    </Box>
  );
};

export default SidebarHeader;
